module.exports = __webpack_public_path__ + "img/android.c55dec11.svg";